import { useColorScheme } from '../../contexts/ColorSchemeContext';
import baseline from '../../app-ui/baseline';
export default function useBadgeStyle() {
  const { resolvedMode } = useColorScheme(),
    c = baseline.tokens[resolvedMode === 'dark' ? 'darkColors' : 'lightColors'];
  return {
    '--badge-primary': c.primary,
    '--badge-on-primary': c.onPrimary,
    '--badge-gold': resolvedMode === 'dark' ? '#F2C94C' : '#8A6700',
    '--badge-gold-bg': resolvedMode === 'dark' ? '#403514' : '#F4E7C4',
    '--badge-text': c.text,
    '--badge-secondary': c.textSecondary,
    '--badge-muted': c.textMuted,
    '--badge-border': c.divider,
    '--badge-surface': c.surfaceSoft,
    '--badge-track': c.surfaceMuted,
    '--badge-bg': c.background,
  };
}
